import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Modal, ModalControlModalProps, Text } from '@frontend/design-system';
import { InfoTipPopover } from '../popover/info-tip-popover';

type Props = {
  autoOpenPopover?: boolean;
  ctaAction?: () => void;
  modalContent?: ReactNode;
  modalProps: ModalControlModalProps;
  noTipContentInModal?: boolean;
  showCallIntelPrefix?: boolean;
  tipContent: ReactNode | string;
  title?: string;
  trackingId?: string;
  onPopoverAutoOpen?: () => void;
};

export const InfoTooltipModal = ({
  autoOpenPopover,
  ctaAction,
  modalContent,
  modalProps,
  noTipContentInModal,
  showCallIntelPrefix = false,
  title,
  tipContent,
  trackingId,
  onPopoverAutoOpen,
}: Props) => {
  const { t } = useTranslation('call-intel-core');

  const displayTitle = showCallIntelPrefix && title ? t('Call Intelligence: {{title}}', { title }) : title;

  return (
    <>
      <InfoTipPopover
        ctaAction={ctaAction}
        title={displayTitle}
        autoOpen={autoOpenPopover}
        onAutoOpen={onPopoverAutoOpen}
      >
        {tipContent}
      </InfoTipPopover>

      <Modal {...modalProps} maxWidth={600}>
        <Modal.Header
          closeBtnTrackingId={`close-modal-for-${trackingId}`}
          css={styles.modalHeader}
          onClose={modalProps.onClose}
        >
          {displayTitle}
        </Modal.Header>
        <Modal.Body>
          {!noTipContentInModal && <Text>{tipContent}</Text>}
          <div css={styles.modalContent}>{modalContent}</div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const styles = {
  modalHeader: css`
    margin-bottom: ${theme.spacing(1)};
  `,

  modalContent: css`
    color: ${theme.colors.text.default};
    margin-top: ${theme.spacing(2)};

    .with-margin {
      margin-top: ${theme.spacing(2)};
    }
  `,
};
